import { createAction, props } from '@ngrx/store';
import { User } from './auth.models';

export const authLogin = createAction('[Auth] Login');
export const authLogout = createAction('[Auth] Logout');

// login
export const authLoginRequest = createAction('[Auth] Login Request', props<{ username: string, password: string }>());   
export const authLoginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());     
export const authLoginSuccess = createAction('[Auth] Login Success', props<{ user: User }>());     

// logout
export const authLogoutRequest = createAction('[Auth] Logout Request');   
export const authLogoutFailure = createAction('[Auth] Logout Failure', props<{ error: string }>());     
export const authLogoutSuccess = createAction('[Auth] Logout Success');     
